// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"603":"5828c3ef","664":"0b9d5434","695":"ab507775"}[chunkId] + ".chunk.css";
};